/* IVIDUS launch countdown (snippets/iv-countdown). Parses "YYYY-MM-DD HH:MM" as Doha time (UTC+3) unless an offset or Z
   is given. At zero it fires "iv:launch" on the element; hosts decide what happens (bar: "now open", password page: wait
   for the shop to open). Updates pause while the tab is hidden. */
(() => {
  if (customElements.get('iv-countdown')) return;
  const parse = (s) => {
    const m = String(s || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?\s*(Z|[+-]\d{2}:?\d{2})?$/i);
    if (!m) return NaN;
    let off = m[7] || '+03:00';
    if (/^[+-]\d{4}$/.test(off)) off = `${off.slice(0, 3)}:${off.slice(3)}`;
    return Date.parse(`${m[1]}-${m[2]}-${m[3]}T${m[4].padStart(2, '0')}:${m[5]}:${m[6] || '00'}${off.toUpperCase() === 'Z' ? 'Z' : off}`);
  };
  window.ivLaunchTime = parse;
  const pad = (n) => String(n).padStart(2, '0');

  class IvCountdown extends HTMLElement {
    connectedCallback() {
      this.at = parse(this.dataset.at);
      if (Number.isNaN(this.at)) { this.classList.add('is-invalid'); return; }
      this.nums = Object.fromEntries([...this.querySelectorAll('[data-iv-cd]')].map((n) => [n.dataset.ivCd, n]));
      const dateEl = this.querySelector('[data-iv-cd-date]');
      if (dateEl) {
        // Shown in the visitor's own time zone, e.g. "15 November 2026 at 18:00 GMT+3"
        let txt;
        try {
          const lang = this.dataset.lang === 'en' ? 'en-GB' : (this.dataset.lang || undefined);
          txt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' }).format(new Date(this.at));
        } catch (e) { txt = new Date(this.at).toLocaleString(); }
        dateEl.textContent = (this.dataset.dateTemplate || '[date]').replace('[date]', txt);
      }
      this.tick = this.tick.bind(this);
      this.onVis = () => { if (!document.hidden) this.tick(); };
      document.addEventListener('visibilitychange', this.onVis);
      this.tick();
    }

    disconnectedCallback() { clearTimeout(this.timer); document.removeEventListener('visibilitychange', this.onVis); }

    tick() {
      clearTimeout(this.timer);
      const left = this.at - Date.now();
      if (left <= 0) {
        Object.values(this.nums).forEach((n) => { n.textContent = '00'; });
        if (!this.done) {
          this.done = true;
          const whileOpen = this.classList.contains('is-running');
          this.classList.add('is-done');
          this.dispatchEvent(new CustomEvent('iv:launch', { bubbles: true, detail: { whileOpen } }));
        }
        return;
      }
      const s = Math.floor(left / 1000);
      const v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      Object.entries(v).forEach(([k, n]) => { if (this.nums[k]) this.nums[k].textContent = pad(n); });
      this.classList.add('is-running');
      if (!document.hidden) this.timer = setTimeout(this.tick, 1000 - (Date.now() % 1000) + 20);
    }
  }
  // Listener first: elements already in the page upgrade (and may finish) during define()
  // Countdown bar: switch to "now open". If this page holds launch products and the launch happened while it was open,
  // reload once so they appear (the launch gate runs on the server).
  document.addEventListener('iv:launch', (e) => {
    const bar = e.target.closest('[data-iv-cdbar]');
    if (!bar) return;
    bar.classList.add('is-live');
    if (!e.detail || !e.detail.whileOpen) return;
    if (!document.querySelector('[data-iv-launch-hidden], .iv-soon')) return;
    const key = `iv_launch_reload_${bar.dataset.at}`;
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (err) { /* storage off: still reload once */ }
    setTimeout(() => window.location.reload(), 2500);
  });
  customElements.define('iv-countdown', IvCountdown);

})();
